module.exports = {"450821001":"平南街道","450821002":"上渡街道","450821101":"平山镇","450821102":"寺面镇","450821103":"六陈镇","450821104":"大新镇","450821105":"大安镇","450821106":"武林镇","450821107":"大坡镇","450821108":"大洲镇","450821109":"镇隆镇","450821112":"安怀镇","450821113":"丹竹镇","450821114":"官成镇","450821115":"思旺镇","450821116":"大鹏镇","450821117":"同和镇","450821118":"东华镇","450821204":"思界乡","450821205":"国安瑶族乡","450821206":"马练瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450821.json
// module id = 2132
// module chunks = 0